import Dom from '../../helpers/dom-helper';

class ShowcaseTheme {
    constructor(domManager) {
        this.accentColor = null;
        this.fontColor = null;
        this.allowContentDownload = null;
        this.organisationName = null;
        this.logoUrl = null;
        this.promoImageUrl = null;
        this.biography = null;

        this.domManager = domManager;

        this.element = null;
    }

    /**
     * Render the style tag
     * @returns {Element}
     */
    render() {
        // eslint-disable-line
        if (this.element !== null) {
            throw new Error('Showcase Theme already rendered');
        }

        let element = null;

        if (this.element === null) {
            element = Dom.createElement('<style></style>');
        } else {
            element = this.element;
        }

        const isWhite = color => ['ffffff', 'f6f6f6'].indexOf(color.toLowerCase()) !== -1;

        // Create style element
        element.innerHTML = `
            .header {
                background-color: #${this.accentColor};
                color: #${this.fontColor};
            }
            .header-actions-list .button { color: #${this.fontColor}; }
            .button-tint {
                background-color: #${this.accentColor} !important;
                color: #${this.fontColor} !important;
                border: 1px solid #${isWhite(this.accentColor) ? 'd9d9d9' : this.accentColor} !important;
            }
            .button-tint--reversed {
                color: #$4d4d4d !important;
            }
            .control--checkbox input[type="checkbox"]:checked + .control__indicator {
                background-color: #${this.accentColor} !important;
                ${isWhite(this.accentColor) ? 'border: 1px solid #737373;' : ''}
            }
            .control--checkbox .control__indicator:after {
                border-color: #f6f6f6 !important;
            }
            a {
                color: #333333;
            }
            .revoked-svg {
                color: #${this.accentColor} !important;
            }
        `;

        // Update the page title to the company name title, some DOM setters
        this.domManager.get('title').innerHTML = `${this.organisationName} | Showpad`;

        if (this.element === null) {
            this.element = element;
        }

        this.domManager.get('body').appendChild(this.element);

        return this.element;
    }

    /**
     * Remove DOM object and references to the object
     */
    destroy() {
        document.querySelector('body').removeChild(this.element);
        this.element = null;
    }

    /**
     * Returns the current element
     * @returns {null|Element}
     */
    getElement() {
        return this.element;
    }

    getInstance() {
        return this;
    }

    /**
     * Create a theme component from given data
     * @param {Object} config
     * @param {Object} organisation
     * @param {DomManager} domManager
     * @returns {ShowcaseTheme}
     */
    static fromConfig(config, organisation, domManager) {
        const theme = new ShowcaseTheme(domManager);

        theme.accentColor = config.accentColor;
        theme.fontColor = config.fontColor;
        // Content color should never be used in showcase-client, reserved for Shared Spaces
        theme.allowContentDownload = config.allowContentDownload;
        theme.logoUrl = config.logoUrl;
        theme.promoImageUrl = config.promoImageUrl;
        theme.biography = config.biography;
        theme.organisationName = (organisation && organisation.name) || '';

        return theme;
    }
}

export default ShowcaseTheme;
